export default function Privacy() {
  return (
    <div className="min-h-screen bg-white py-20">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
        <h1 className="font-heading text-4xl font-bold text-slate-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-8">
            Last updated: December 2024
          </p>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">1. Information We Collect</h2>
            <p className="text-slate-600 mb-4">
              The American Real Estate Alliance ("AREA", "we", "us", or "our") collects information you provide directly to us, including:
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>Name, email address, and contact information</li>
              <li>Professional credentials and license information</li>
              <li>Payment and billing information</li>
              <li>Communications and correspondence with us</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">2. How We Use Your Information</h2>
            <p className="text-slate-600 mb-4">We use the information we collect to:</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process membership applications and payments</li>
              <li>Send you technical notices and support messages</li>
              <li>Communicate about events, resources, and updates</li>
              <li>Respond to your comments, questions, and requests</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">3. Information Sharing</h2>
            <p className="text-slate-600">
              We do not sell your personal information. We may share your information with service providers who assist us in operating our platform, conducting our business, or serving our members, so long as those parties agree to keep this information confidential.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">4. Member Directory</h2>
            <p className="text-slate-600">
              As an AREA member, your professional information may be displayed in our member directory. You can control what information is visible through your privacy settings in your member dashboard.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">5. Data Security</h2>
            <p className="text-slate-600">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">6. Your Rights</h2>
            <p className="text-slate-600 mb-4">You have the right to:</p>
            <ul className="list-disc list-inside text-slate-600 space-y-2">
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-heading text-2xl font-semibold text-slate-900 mb-4">7. Contact Us</h2>
            <p className="text-slate-600">
              If you have any questions about this Privacy Policy, please contact us at privacy@area.org.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
